import { Base } from "ui/Scripts/source/framework/base";
import { FrontPageBannerImage, IFrontPageBannerImage } from "./frontPageBannerImage";

export interface IFrontPageBanner {
    images: IFrontPageBannerImage[];
    imageChangeInterval: number;
}

export class FrontPageBanner implements IFrontPageBanner {
    images: FrontPageBannerImage[];
    imageChangeInterval: number;

    constructor();
    constructor(obj: IFrontPageBanner);
    constructor(obj?: any) {
        this.imageChangeInterval = obj && obj.imageChangeInterval || 0;
        this.images = Base.getTypedArray(obj ? obj.images : null, FrontPageBannerImage);
    }
}